import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateDesignDocument } from './create.generated';

export const useCreateDesign = (options: ApiOptions<typeof CreateDesignDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateDesignDocument, {
    ...useNotifications(CreateDesignDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.designs.create_success'),
    }),
    ...options,
  });
};
